import { EDCItem, EDCItemStatus } from '../types/edc-status.type';

export const EDCStatusMap: Record<EDCItemStatus, EDCItem> = {
  [EDCItemStatus.STATUS_AVAILABLE]: {
    bgColor: '#EDFFF1',
    borderColor: '#01CBAD',
    color: '#08675D',
    text: 'Available',
  },
  [EDCItemStatus.STATUS_AWAITING_UPLOAD]: {
    bgColor: '#E5E7EB    ',
    borderColor: '#D1D5DB',
    color: '#4f6d79',
    text: 'Awaiting Upload',
  },
  [EDCItemStatus.STATUS_PROCESSING]: {
    bgColor: '#FFE5BF',
    borderColor: '#C44000',
    color: '#C44000',
    text: 'Processing',
  },
};

export const EDCStatusBannerMap: Record<EDCItemStatus, EDCItem> = {
  [EDCItemStatus.STATUS_AVAILABLE]: {
    bgColor: '#C7FFF2',
    borderColor: '#01CBAD',
    color: '#00A48F',
    text: 'Available',
  },
  [EDCItemStatus.STATUS_AWAITING_UPLOAD]: {
    bgColor: '#F6F6F9',
    borderColor: '#B2B5C7',
    color: '#696F8E',
    text: 'Awaiting Upload',
  },
  [EDCItemStatus.STATUS_PROCESSING]: {
    bgColor: '#FFE5BF',
    borderColor: '#FDDE68',
    color: '#C44000',
    text: 'Processing',
  },
};
